import { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from '@ui/components/Modal'

import { Box } from '@shared/components/Box'

interface PaginatedDetailsModalProps<T> {
  items: T[]
  initialIndex: number
  title: (item: T) => ReactNode
  children: (item: T) => ReactNode
}

export function PaginatedDetailsModal<T>({
  items,
  initialIndex,
  title,
  children,
}: PaginatedDetailsModalProps<T>) {
  const { t } = useTranslation()

  const [currentIndex, setCurrentIndex] = useState(initialIndex)

  if (items.length === 0) {
    return null
  }

  const item = items[currentIndex]

  return (
    <Modal.FullScreen>
      <Modal.Header canClose>{title(item)}</Modal.Header>
      <Modal.Body>
        <Box flex direction='column' gap='x8' align='flex-start' fullWidth>
          {children(item)}
        </Box>
      </Modal.Body>
      <Modal.Footer direction='row'>
        <Modal.Footer.Secondary
          onClick={() => setCurrentIndex((i) => i - 1)}
          disabled={currentIndex === 0}
        >
          {t('Campaigns.Previous')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Secondary
          onClick={() => setCurrentIndex((i) => i + 1)}
          disabled={currentIndex === items.length - 1}
        >
          {t('Campaigns.Next')}
        </Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal.FullScreen>
  )
}
